let anchorLines, mainHeader
let isRunning = false

const setMenuHeight = () => {
    if (window.innerWidth > 991 && anchorLines) {
        const isScrollDown = mainHeader.classList.contains('scroll-down')
        const isScrollUp = mainHeader.classList.contains('scroll-up')
        const currentTop = anchorLines.style.top

        if (isScrollDown && currentTop !== '20px') {
            anchorLines.style.top = '20px'
        } else if (isScrollUp) {
            const newTop = `${mainHeader.offsetHeight + 20}px`
            if (currentTop !== newTop) {
                anchorLines.style.top = newTop
            }
        }
    }
    isRunning = false
}

const optimizedSetMenuHeight = () => {
    if (!isRunning) {
        isRunning = true
        requestAnimationFrame(() => {
            setMenuHeight()
        })

        if (anchorLines) {
            anchorLines.classList.toggle('anchor-line-top', mainHeader.classList.contains('scroll-down'))
        }
    }
}

const initMenuSticky = () => {
    anchorLines = document.querySelector('.sticky-menu')
    mainHeader = document.querySelector('.l-header')
    setMenuHeight()
    window.addEventListener('scroll', optimizedSetMenuHeight)
    window.addEventListener('resize', optimizedSetMenuHeight)
}

export { initMenuSticky }

